export default __webpack_public_path__ + "static/media/techno-logo.ce6ed440.png";